var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Header'),_c('div',{staticClass:"content"},[_c('ResetPasswordForm',{attrs:{"token":_vm.theToken}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }